export default __webpack_public_path__ + "static/media/coffee.18312a3d.svg";